<template>
  <div class="featured-product-modal-component">
    <b-modal
      id="featured-product-preview"
      size="xl"
      hide-footer
      hide-header
      @shown="getFeaturedProductSlug(productSlug)"
    >
      <div class="product-modal">
        <div class="row no-gutters">
          <div class="col-12 text-center spinner" v-show="processing">
            <i class="fas fa-spinner fa-spin fa-5x"></i>
          </div>
          <div class="d-none d-lg-block col-lg-6" v-show="!processing">
            <ProductCarousel :productImages="productImages"></ProductCarousel>
          </div>
          <div class="col-12 col-lg-6" v-show="!processing">
            <ProductDetails :productDetails="productDetails"></ProductDetails>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import ProductCarousel from "@/components/store/ProductCarousel";
import ProductDetails from "@/components/store/ProductDetails";

export default {
  name: "FeaturedProductModal",
  props: {
    productSlug: String,
  },
  data() {
    return {
      productDetails: undefined,
      productImages: [],
      processing: false,
    };
  },
  components: {
    ProductCarousel,
    ProductDetails,
  },
  methods: {
    getFeaturedProductSlug(slug) {
      this.processing = true;
      axios.get(`/product/${slug}`).then((response) => {
        this.processing = false;
        this.productDetails = response.data.product;
        this.productImages = [response.data.product.image, ...response.data.product.images];
      });
    },
  },
};
</script>


<style lang="sass" scoped>
.product-modal
  height: 555px

.fa-5x
  font-size: 5rem

.spinner
  position: absolute
  top: 40%
</style>
